import React, { useEffect, useRef, useState } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import { useDispatch } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import { salesInvoiceViewAction } from "../../../redux/actions/sales-action";
import CreateEditViewSalesInv from "../../../components/sales-section/sales-invoice/create-edit-view-sales-Inv";
const ITEMS_PER_PAGE = 50;

const getItemKey = (item) => `${item?.item_id ?? ""}-${item?.sodtt_id ?? ""}`;

const SalesInvoiceEdit = () => {
  const { id } = useParams();
  const [orderDetail, setOrderDetail] = useState({});
  const [invoiceItems, setInvoiceItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [frameNumber, setFrameNumber] = useState(0);
  const dispatch = useDispatch();
  const itemsRef = useRef([]);
  const fetchedFramesRef = useRef(new Set());
  useEffect(() => {
    if (fetchedFramesRef.current.has(frameNumber)) return;
    fetchedFramesRef.current.add(frameNumber);
    dispatch(
      salesInvoiceViewAction(
        {
          id,
          frame_number: frameNumber,
          limit: ITEMS_PER_PAGE,
          for_clone: false,
        },
        onSuccPur,
        onErrPur
      )
    );
  }, [frameNumber]);

  const onSuccPur = (data) => {
    // The endpoint returns { data: [invoice] }; the second arm covers the
    // paginated envelope ({ data: { data: [invoice], next_sequence_exist } })
    // for if/when the backend is switched over to it.
    const result = data?.data?.[0] ?? data?.data?.data?.[0];
    setOrderDetail(result);

    const newItems = result?.itemData ?? [];
    const seen = new Set(itemsRef.current.map(getItemKey));
    const uniqueNewItems = newItems.filter((item) => !seen.has(getItemKey(item)));
    itemsRef.current = [...itemsRef.current, ...uniqueNewItems];
    setInvoiceItems(itemsRef.current);

    // The edit form submits whatever items it is given, so every frame has to
    // be loaded before it is rendered - a partial list would drop line items.
    if (data?.data?.next_sequence_exist && uniqueNewItems.length) {
      setFrameNumber((prev) => (data?.data?.frame_number ?? prev) + 1);
    } else {
      setLoading(false);
    }
  };

  const onErrPur = (data) => {
    setLoading(false);
  };

  const [searchParams] = useSearchParams();
  const isNew = searchParams.has("new");
  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <InnerLayout backBtn={true} title="Edit Sales Invoice">
          <CreateEditViewSalesInv
            clickedplus={isNew}
            payto={orderDetail?.orderData?.soit_pay_to_address}
            shipto={orderDetail?.orderData?.soit_ship_to_address}
            pageType="invoice"
            page="edit"
            type={"delivery"}
            standAlone={true}
            disabled={
              true && orderDetail?.orderData?.soit_order_status !== "draft"
            }
            orderDetail={invoiceItems}
            vendorDetails={[orderDetail?.orderData]}
          />
        </InnerLayout>
      )}
    </>
  );
};
export default SalesInvoiceEdit;

